"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = ({
  className
}) => {
  return _react.default.createElement(_SvgIcon.default, {
    className: className
  }, _react.default.createElement("path", {
    d: "M1.29938 17.977C0.505839 19.3102 1.46651 21 3.01797 21H20.982C22.5335 21 23.4942 19.3102 22.7006 17.977L13.7186 2.88722C12.9432 1.58451 11.0568 1.58451 10.2814 2.88722L1.29938 17.977Z",
    fill: "#F2994A"
  }), _react.default.createElement("path", {
    d: "M14.848 18V17.04H11.104L14.008 13.524C14.464 12.96 14.716 12.408 14.716 11.748C14.716 11.22 14.584 10.812 14.332 10.452C13.912 9.864 13.168 9.492 12.256 9.492C10.78 9.492 9.76001 10.476 9.76001 11.928H10.816C10.816 10.824 11.524 10.416 12.268 10.416C13.144 10.416 13.672 10.908 13.672 11.76C13.672 12.192 13.54 12.576 13.216 12.96L9.77201 17.124V18H14.848Z",
    fill: "white"
  }));
};

exports.default = _default;
module.exports = exports.default;